import { useEffect, useState } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const justCreated = sessionStorage.getItem('justCreatedAccount') === 'true';
        if (justCreated) {
          sessionStorage.removeItem('justCreatedAccount');
          setIsSubscribed(false);
          setUser(firebaseUser);
          setLoading(false);
          setSubscriptionChecked(true);
          return;
        }
        try {
          const docRef = doc(db, 'subscribers', firebaseUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists() && docSnap.data().active === true) {
            setIsSubscribed(true);
            setUser({ ...firebaseUser, tier: docSnap.data().tier || 'decoder' });
          } else {
            setIsSubscribed(false);
            setUser(firebaseUser);
          }
        } catch (err) {
          console.error('Subscription check failed:', err);
          setIsSubscribed(false);
          setUser(firebaseUser);
        }
      } else {
        setUser(null);
        setIsSubscribed(false);
      }
      setLoading(false);
      setSubscriptionChecked(true);
    });
    return () => unsubscribe();
  }, []);

  if (loading || !subscriptionChecked) {
    return (
      <div style={{minHeight:'100vh',background:'#F9F7F4',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{fontFamily:"'Jost',sans-serif",color:'#9A8F85',fontSize:'14px'}}>Loading...</div>
      </div>
    );
  }

  if (user && isSubscribed) {
    return <Dashboard user={user} />;
  }

  return (
    <Login
      onLoginSuccess={(u) => { setUser(u); setIsSubscribed(true); }}
      setNewUser={() => {}}
      existingUser={user}
    />
  );
}

export default App;
